'use client';

import getConfig from 'next/config';
export default function useFeatureSwitch(_ref) {
  var featureSwitchKey = _ref.featureSwitchKey,
    country = _ref.country,
    _ref$fallbackValue = _ref.fallbackValue,
    fallbackValue = _ref$fallbackValue === void 0 ? false : _ref$fallbackValue;
  var _ref2 = getConfig() || {},
    _ref2$publicRuntimeCo = _ref2.publicRuntimeConfig,
    publicRuntimeConfig = _ref2$publicRuntimeCo === void 0 ? {} : _ref2$publicRuntimeCo;
  if (country) {
    featureSwitchKey += "_".concat(country.toUpperCase());
  }
  var isFeatureEnabled = publicRuntimeConfig[featureSwitchKey] ? publicRuntimeConfig[featureSwitchKey].toLowerCase() === 'true' : fallbackValue;
  return isFeatureEnabled;
}